import { FC, useState } from 'react';
import { SearchableProvider } from '../../../../../lib/components/SearchableDataTable/SearchableProvider';
import { PageLayout } from '../../../../../lib/shell/PageLayout/PageLayout';
import { SearchTagDto } from '../dto/SearchTagDto';
import { SearchTagEditModal } from '../components/SearchTagEditModal';
import { SearchTagInsertModal } from '../components/SearchTagInsertModal';
import { SearchTagsDatatable } from '../components/SearchTagsDatatable';

export const AuthorTagListPage: FC = () => {
	const [remove_counter, set_remove_counter] = useState(0);
	const [insert_counter, set_insert_counter] = useState(0);
	const [update_counter, set_update_counter] = useState(0);
	const [visible_form_insert, set_visible_form_insert] = useState(false);
	const [tag_to_edit, set_tag_to_edit] = useState<SearchTagDto | null>(null);

	return (
		<PageLayout title='Tag de Autor'>
			<SearchableProvider
				{...{
					key: `tag-list-${insert_counter}-${remove_counter}-${update_counter}`,
					entity_name: 'admin-search-tags-entity',
					default_query: {
						limit: 20,
						page: 1,
						sort: 'sort1',
						sort_dir: 'desc',
						tags: 'author',
						text: '',
					},
				}}
			>
				<SearchTagsDatatable
					{...{
						title_of_the_item_to_be_removed: 'tag de autor',
						on_remove_success: () => set_remove_counter(remove_counter + 1),
						visible_insert_modal: () => set_visible_form_insert(true),
						on_edit_click: (tag) => set_tag_to_edit(tag),
						show_cpf_column: true,
					}}
				/>
			</SearchableProvider>
			<SearchTagInsertModal
				{...{
					tag_name_in_portuguese: 'Tag de Autor',
					prefix: 'author',
					visible: visible_form_insert,
					close: () => set_visible_form_insert(false),
					insert_success: () => set_insert_counter(insert_counter + 1),
				}}
			/>
			<SearchTagEditModal
				{...{
					tag_name_in_portuguese: 'Tag de Autor',
					tag: tag_to_edit,
					visible: !!tag_to_edit,
					close: () => set_tag_to_edit(null),
					update_success: () => set_update_counter(update_counter + 1),
				}}
			/>
		</PageLayout>
	);
};
